const Organization = ({ className }: { className?: string }) => (
  <svg
    width="44"
    height="48"
    viewBox="0 0 44 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M13.5 8.5C13.5 3.80558 17.3056 0 22 0C26.6944 0 30.5 3.80558 30.5 8.5C30.5 12.6826 27.479 16.1596 23.5 16.8681V23.0045H32.5C34.9853 23.0045 37 25.0192 37 27.5045V31.1364C40.979 31.8449 44 35.3219 44 39.5045C44 44.1989 40.1944 48.0045 35.5 48.0045C30.8056 48.0045 27 44.1989 27 39.5045C27 35.3219 30.021 31.8449 34 31.1364V27.5045C34 26.6761 33.3284 26.0045 32.5 26.0045H11.5C10.6716 26.0045 10 26.6761 10 27.5045V31.1364C13.979 31.8449 17 35.3219 17 39.5045C17 44.1989 13.1944 48.0045 8.5 48.0045C3.80558 48.0045 0 44.1989 0 39.5045C0 35.3219 3.02098 31.8449 7 31.1364V27.5045C7 25.0192 9.01472 23.0045 11.5 23.0045H20.5V16.8681C16.521 16.1596 13.5 12.6826 13.5 8.5Z"
      fill="currentColor"
    />
  </svg>
);

export default Organization;
